// extracted by mini-css-extract-plugin
export default {"pie-container":"PieChart_pie-container__SIzV0","pie-title":"PieChart_pie-title__iN07P"};